module.exports = __webpack_public_path__ + "static/media/top-menu.1655bc6f.svg";